import QuestionnaireWizard from './QuestionnaireWizard';

export default QuestionnaireWizard;
